"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.lootParams = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.startAction = startAction;
exports.reducer = reducer;

var _reselect = require("reselect");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _stats = require("../units/stats");

var _util = require("../../../util");

var Util = _interopRequireWildcard(_util);

var _zoneTypes = require("../../../entities2/zone-types");

var ZoneTypes = _interopRequireWildcard(_zoneTypes);

var _now = require("../../now");

var Now = _interopRequireWildcard(_now);

var _raw = require("../raw");

var RawChar = _interopRequireWildcard(_raw);

var _zones = require("../zones");

var Zones = _interopRequireWildcard(_zones);

var _actionBase = require("../action-base");

var Actions = _interopRequireWildcard(_actionBase);

var _combat = require("../units/combat");

var UnitsCombat = _interopRequireWildcard(_combat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startAction(zone) {
  return { type: "COMBAT_START", zone: zone };
}

function decToNum(decs) {
  return _lodash2.default.mapValues(decs, function (dec) {
    return dec.toNumber();
  });
}
function initSoldiers(counts) {
  // starting lair is hardcoded
  return _lodash2.default.mapValues(_extends({}, counts, { lair: 1 }), function (count) {
    return { count: count, deaths: 0, hp: 0 };
  });
}
var lootParams = exports.lootParams = (0, _reselect.createStructuredSelector)({
  isZoneCleared: Zones.isCleared,
  isGrind: UnitsCombat.isGrind
});
var init = exports.init = (0, _reselect.createStructuredSelector)({
  init: (0, _reselect.createStructuredSelector)({
    player: (0, _reselect.createStructuredSelector)({
      soldiers: (0, _reselect.createSelector)(UnitsCombat.soldiers, _lodash2.default.flow(decToNum, initSoldiers))
    }),
    enemy: (0, _reselect.createStructuredSelector)({
      soldiers: (0, _reselect.createSelector)(ZoneTypes.soldiers, initSoldiers)
    }),
    event: (0, _reselect.createStructuredSelector)({
      type: function type() {
        return "COMBAT_START";
      },
      zone: function zone(s, p) {
        return p.zone;
      },
      createdAt: Now.now
    }),
    params: lootParams
  })
});
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "COMBAT_START":
      {
        // TODO reject if combat is running
        var _fixedNow = action.createdAt,
            _zone = action.zone,
            root = action.root,
            _character = action.character;

        return init(root, { zone: _zone, character: _character, fixedNow: _fixedNow });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/combat/init.js
// module id = 360
// module chunks = 0